import React from "react";
import { useNavigate } from "react-router-dom";

const sports = [
  { name: "Cricket", tag: "Most Popular", path: "/sports/cricket", emoji: "🏏" },
  { name: "Football", tag: "Live", path: null, emoji: "⚽" },
  { name: "Basketball", tag: "Live", path: null, emoji: "🏀" },
  { name: "Tennis", tag: "Upcoming", path: null, emoji: "🎾" },
  { name: "Esports", tag: "Trending", path: null, emoji: "🎮" },
];

export default function SportsPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#101728] text-white p-4 md:p-6">
      <div className="max-w-6xl mx-auto">
        <h1 className="text-2xl md:text-3xl font-extrabold">Sports</h1>
        <p className="text-slate-300 mt-1">Choose your sport and jump into live markets.</p>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4 mt-6">
          {sports.map((sport) => (
            <button
              key={sport.name}
              onClick={() => (sport.path ? navigate(sport.path) : null)}
              className="text-left rounded-xl p-4 bg-slate-900 border border-slate-700 hover:border-emerald-400 transition disabled:opacity-60"
              disabled={!sport.path}
            >
              <div className="text-3xl">{sport.emoji}</div>
              <div className="mt-3 font-bold">{sport.name}</div>
              <div className="text-xs text-emerald-300 mt-1">{sport.tag}</div>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
